<template>
  <div>
    <Head title="Detail Info Mutasi Item Asset" />
    <h1 class="mb-8 text-3xl font-bold">
      Inventaris
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/item_assets">
        Item Asset
      </Link>
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" :href="`/item_assets/${itemAsset.id}/edit`">
        {{ props.itemAsset.item_name }}
      </Link>
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" :href="`/item_assets/${itemAsset.id}/mutasi`">
        Mutasi
      </Link>
      <span class="text-indigo-400 font-medium"> / </span>
      {{ logAsset.event_date }} ({{ logAsset.asset_event }})
    </h1>
    <div class="max-w-4xl bg-white rounded-md shadow overflow-hidden">
      <div id="sectionHeader">
        <div id="sectionEx" class="px-6 py-4 max-w-4xl bg-white rounded-md shadow overflow-hidden">
          <a
            class="text-ellipsis hover:bg-blue-50 flex items-center justify-between mb-3 py-2 whitespace-nowrap rounded cursor-pointer overflow-hidden transition duration-300 ease-in-out"
            data-mdb-ripple="true"
            data-mdb-ripple-color="primary"
            data-bs-toggle="collapse"
            data-bs-target="#collapsesectionEx"
            aria-expanded="false"
            aria-controls="collapsesectionEx">
            <span class="text-xl font-bold">Detail Info Asset {{ props.itemAsset.item_name }} [{{ props.itemAsset.asset_no }}] </span>
            <Icon icon="fa6-solid:chevron-down" class="ml-1 w-8 h-8 fill-gray-500" />
          </a>
          <ul
            id="collapsesectionEx"
            class="accordion-collapse collapse relative"
            aria-labelledby="sectionEx"
            data-bs-parent="#sectionHeader">
            <div class="flex flex-wrap p-2">
              <text-input
                :model-value="props.itemAsset.item_name"
                class="pb-8 pr-6 w-1/2"
                label="Nama Barang"
                disabled />
              <text-input
                :model-value="props.itemAsset.asset_no"
                class="pb-8 pr-6 w-1/2"
                label="No. Inventaris"
                disabled />
              <text-input
                :model-value="props.itemAsset.barcode01"
                class="pb-8 pr-6 w-1/2"
                label="Barcode 01"
                disabled />
              <text-input
                :model-value="props.itemAsset.barcode02"
                class="pb-8 pr-6 w-1/2"
                label="Barcode 02"
                disabled />
              <text-input
                :model-value="props.itemAsset.condition"
                class="pb-8 pr-6 w-full md:w-1/3"
                label="Barcode 02"
                disabled />
              <text-input
                :model-value="props.itemAsset.status"
                input-class="font-bold text-center"
                class="pb-8 pr-6 w-1/2 md:w-1/3"
                label="Status Asset"
                disabled />
              <text-input
                :model-value="props.itemAsset.asset_ownership"
                class="pb-8 pr-6 w-full md:w-1/3"
                label="Asset Ownership"
                disabled />
              <text-input
                :model-value="props.itemAsset.project_name"
                class="pb-8 pr-6 w-full md:w-1/3"
                label="Sumber Data (Project)"
                disabled />
              <text-input
                :model-value="props.itemAsset.employee_name"
                class="pb-8 pr-6 w-1/2 md:w-1/3"
                label="Penanggung Jawab"
                disabled />
              <text-input
                :model-value="props.itemAsset.item_location_name"
                class="pb-8 pr-6 w-1/2 md:w-1/3"
                label="Lokasi Item"
                disabled />
              <div class="pb-8 pr-6 w-full md:w-1/2">
                <label class="props.logAsset.label">Harga Beli:</label>
                <number-input :value="props.itemAsset.purchase_price" disabled />
              </div>
              <div class="pb-8 pr-6 w-full md:w-1/3">
                <label class="props.logAsset.label">Perkiraan Depresiasi Tahunan:</label>
                <number-input :value="props.itemAsset.depreciation_rate" disabled />
              </div>
              <textarea-input
                :model-value="props.itemAsset.desc"
                label="Deskripsi Asset"
                class="pb-8 pr-6 w-full md:w-1/2"
                readonly />
              <text-input
                :model-value="props.itemAsset.purchase_date"
                input-class="text-center"
                label="Tanggal Pengadaan"
                class="pb-8 pr-6 w-full md:w-1/3"
                disabled />
            </div>
          </ul>
        </div>
      </div>
    </div>
    <div class="mt-2 max-w-4xl bg-white rounded-md shadow overflow-hidden">
      <div class="px-6 py-4">
        <span class="text-xl font-bold">Tindakan Mutasi</span>
      </div>
      <form @submit.prevent="submitMutasi">
        <div class="flex flex-wrap -mr-6 px-8 py-2">
          <text-input
            :model-value="props.logAsset.asset_event"
            class="pb-8 pr-6 w-1/2 md:w-1/3"
            label="Jenis Event"
            disabled />
          <text-input
            :model-value="props.logAsset.event_date"
            class="pb-8 pr-6 w-1/2 md:w-1/3"
            label="Tanggal Mutasi"
            disabled />
          <div class="w-full" />
          <textarea-input
            :model-value="props.logAsset.desc"
            label="Penjelasan terkait mutasi"
            class="pb-8 pr-6 w-full md:w-2/3"
            rows="4"
            disabled />
        </div>
        <div class="-mr-6 px-8 py-4 bg-gray-50 border-t border-gray-100" id="attachments">
          <h3 class="text-xl">
            List berkas pendukung:
          </h3>

          <ul
            v-for="(docfile, idx) in logAsset.files"
            :key="idx"
            class="w-full list-disc">
            <li class="flex gap-2 items-center">
              <span>- </span>
              <a
                :href="docfile.url"
                :class="attachmentAccess.download ? 'text-indigo-500 underline' : 'text-red-600'"
                target="_blank"
                :download="docfile.file_name"
                :disable="!attachmentAccess.download"> {{ docfile.file_name }}</a> ( {{ docfile.size }} )
              <a
                href=""
                title="Delete attachment file"
                @click.prevent="destroyAttachment(docfile.uuid)">
                <Icon icon="ic:baseline-delete-forever" class="w-6 h-6 text-red-600" />
              </a>
            </li>
          </ul>

          <file-input
            v-model="form.attachment"
            :error="form.errors.attachment"
            class="pr-6 py-4 w-full md:w-2/3"
            type="file"
            accept="image/*, application/pdf"
            label="Browse dan upload file dokumen pendukung (Max 10MB)"
            @update:model-value="uploadAttachment"
            v-if="attachmentAccess.upload" />
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import Layout from '@/Shared/Layout.vue'

export default {
    layout: Layout,
}
</script>

<script setup>
import { Head, Link, useForm, router } from '@inertiajs/vue3'
import TextInput from '@/Shared/TextInput.vue'
import TextareaInput from '@/Shared/TextareaInput.vue'
import NumberInput from '@/Shared/NumberInput'
import FileInput from '@/Shared/FileInput'
import { Icon } from '@iconify/vue'

const props = defineProps({
    itemAsset: Object,
    logAsset: Object,
    attachmentAccess: Object,
})

const form = useForm({
    attachment: null,
})

const uploadAttachment = () => {
    form.attachment && update()
}

const update = () => {
    router.post(
    `/log_assets/${props.logAsset.id}`,
    {
        _method: 'put',
        attachment: form.attachment,
    },
    {
        preserveScroll: true,
        onSuccess: () => form.reset('attachment'),
    },
    )
}
</script>
